
const app = {
    namespaced: true,

    state: {
        loading: false,
        dialogClienti: false,
        listaClienti: [],
    },

    mutations: {

        SET_LOADING(state, vis) {
            state.loading = vis
        },


        //dialog lista clienti
        setDialogClienti(state, data) {
            state.dialogClienti = data
        },
        //lista Clienti
        setListaClienti(state, data) {
            state.listaClienti = data
        },
    },



    getters: {
        getDialogClienti: state => state.dialogClienti,
        getListaClienti: state => state.listaClienti,
    }


}

export default app